import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UsuarioPermissaoService } from '@services/usuario-permissao.service';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs/operators';
import { CnpjPipe } from 'src/app/pipes/cnpj.pipe';
import { BaseFormService } from 'src/app/services/base-form.service';
import { ListarPedidosPosPagoService } from 'src/app/services/listar-pedidos-pos-pago.service';
import { WindowReferenceService } from '@services/window-reference.service';
import { LoadingGenericoComponent } from '../../components/loading-generico/loading-generico.component';
import { HeaderComponent } from '../../components/header/header.component';
import { NgClass, AsyncPipe, CurrencyPipe, DatePipe } from '@angular/common';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { SelectComponent } from '../../components/select/select.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { CnpjPipe as CnpjPipe_1 } from '../../pipes/cnpj.pipe';
import { UsuarioPermissaoPipe } from '../../pipes/usuario-permissao.pipe';

@Component({
    selector: 'app-listar-pedidos-pos-pago',
    templateUrl: './listar-pedidos-pos-pago.component.html',
    styleUrls: ['./listar-pedidos-pos-pago.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [CnpjPipe],
    imports: [LoadingGenericoComponent, HeaderComponent, FormsModule, NgClass, ReactiveFormsModule, BreadcrumbComponent, SelectComponent, FooterComponent, AsyncPipe, CurrencyPipe, DatePipe, CnpjPipe_1, UsuarioPermissaoPipe]
})
export class ListarPedidosPosPagoComponent
  extends BaseFormService
  implements OnInit {
  public form: UntypedFormGroup;

  public loadingGenerico = false;
  public resources: any = [];
  public empresa: any = localStorage.idEmpresaLogada;
  public empresaSelecionada: any = '0';
  public trocarSenha: boolean = false;
  public empresaChecked: any = [];
  public inputSelecionados: any = [];
  public idPedido: any;
  public erroDetalhe: any = '';
  public empresaSelecionadaOptions = []

  // TABELA
  public listaPedidos: any;
  // SELECT
  public selectAll: boolean;
  public checkedUsersId = [];

  // STATUS API
  public listaPedidosPosPagoApi: boolean;
  public aprovaPedidoApi: boolean;

  //ALERT
  public alertSucessoSubtitulo: any = 'Sucesso !';
  public alertSucessoMensagem: any = '';
  public alertInconsistenciaSubtitulo: any = 'Alerta !';
  public alertInconsistenciaMensagem: any =
    'Ocorreu um erro ao adicionar alguns pedidos. Confira o erro na tela de listar pedidos.';
  public alertErroSubtitulo: any = 'Erro ao liberar pedido !';
  public alertErroMensagem: string = '';
  public alertSucesso: boolean = false;
  public erro: boolean = false;
  public alertInconsistencia: boolean = false;

  // SENHAS
  public showInserirSenha: boolean;
  public showCadastrarSenha: boolean = false;
  public hide = true;
  public ultimaAlteracao: Date = new Date();
  public mensagemSenha: string = '';
  public senhaForca: string = 'Forte';
  public forca = 0;
  public senha: string;
  public confirmarSenha: string;
  public confereSenha: boolean = false;
  public mensagemSenhaIguais: string;
  public informarCaracter: string = '';
  public informarLetras: string = '';
  public informarNumeros: string = '';
  public confereNumero: boolean = false;
  public checkSelectAllClick: boolean = false;
  public senhaAtual: any;

  public filtro: boolean = false;
  public mensagemErro: any;

  obj: any = {
    confirmSenha: 'string',
    idPedidos: [0],
    novaSenha: 'string',
    senhaAtual: 'string',
  };

  public selectAllPed: any;
  public checkedUsersIdAll: any;
  public nok: number = 0;
  public ok: number = 0;

  constructor(
    private readonly listarPedidosPosPagoService: ListarPedidosPosPagoService,
    private readonly Toastr: ToastrService,
    private readonly formBuilder: UntypedFormBuilder,
    public usuarioPermissaoService: UsuarioPermissaoService,
    private readonly cnpjPipe: CnpjPipe,
    private readonly windowRef: WindowReferenceService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.getAllEmpresas();
    this.getAllPedidos();
    this.createForm();
  }

  createForm() {
    this.form = this.formBuilder.group({
      senha: [null, [Validators.required]],
      confirmarSenha: [null, [Validators.required]],
      senhaAtual: [null, [Validators.required]],
    });
  }

  getAllEmpresas() {
    this.listarPedidosPosPagoService.getAllEmpresas(this.empresa)
    .pipe(take(1))
    .subscribe({
      next: (success: any) => {
        this.resources = success.response;
        this.empresaSelecionadaOptions = this.resources.map(empresa => ({
          value: empresa.idEmpresa,
          description: this.cnpjPipe.transform(empresa.cnpj)
        }));
      },
      error: (error) => {
        this.Toastr.error('Erro ao fazer requisição');
      }
    });
  }

  getAllPedidos() {
    let paramsArray = this.getParamsFormatArray();
    let paramsUrl = this.getParamsUrl(paramsArray);
    this.loadingGenerico = true;
    this.listarPedidosPosPagoService.getAllPedidos(this.empresa, paramsUrl)
    .pipe(take(1))
    .subscribe({
      next: (success: any) => {
        this.loadingGenerico = false;
        this.listaPedidos = success.response.pedidos;

        for (const pedido of this.listaPedidos) {
          if (pedido.erroPedido) {
            pedido.statusFinanceiro = pedido.erroDetalhe;
          }
        }

        this.trocarSenha = success.response.alterarSenha;
        this.erroDetalhe = success.response.pedidos[0].erroDetalhe;
      },
      error: (error) => {
        this.listaPedidos = null;
        this.loadingGenerico = false;
        this.mensagemErro = error.error.mensagem;
      }
    });
  }

  getParamsFormatArray() {
    let arr = [];

    if (this.filtro === true) {
      arr.push({ name: 'filtro', comparator: '=', value: this.filtro });
    }

    else if(localStorage.empresaPai == 'false'){
      arr.push({ name: 'filtro', comparator: '=', value: true });
    }

    return arr;
  }

  checkboxTableClick(user) {
    if (user) {
      let res = this.checkedUsersId.findIndex((x) => {
        return x == user.idPedido.toString();
      });

      if (res < 0) {
        this.checkedUsersId.push(user.idPedido.toString());
      } else {
        this.checkedUsersId.splice(res, 1);
      }
    }
  }

  onTableAddressClick(user) {
    let index = this.checkedUsersId.findIndex((x) => x == user);
    if (index < 0) {
      this.checkedUsersId.push(user);
    } else {
      this.checkedUsersId.splice(index, 1);
    }

    this.checkedUsersIdAll = this.checkedUsersId.length;

    if (this.checkedUsersId.length == this.listaPedidos.length) {
      this.selectAllPed = true;
    } else {
      this.selectAllPed = false;
    }
  }

  selectAllUserId(event: any) {
    if (
      this.checkedUsersId.length == this.listaPedidos.length ||
      !event.target.checked
    ) {
      this.checkedUsersId = [];
    } else {
      this.checkedUsersId = [];

      this.listaPedidos.forEach((element) => {
        this.checkedUsersId.push(element.idPedido);
      });
    }

    if (this.checkedUsersId.length == this.listaPedidos.length) {
      this.selectAllPed = true;
    } else {
      this.selectAllPed = false;
    }
  }

  isChecked(idPedido) {
    let index = this.checkedUsersId.findIndex((x) => x == idPedido);

    return index >= 0;
  }

  postSenha() {
    this.obj.senhaAtual = this.form.value.senhaAtual;
    this.obj.novaSenha = this.form.value.senha;
    this.obj.confirmSenha = this.form.value.confirmarSenha;
    this.obj.idPedidos = this.checkedUsersId;
    this.enviarSenha(() => this.cadastrarSenhaFechou());
  }

  postSenhaInsira() {
    this.obj.senhaAtual = this.senhaAtual;
    this.obj.novaSenha = '';
    this.obj.confirmSenha = '';
    this.obj.idPedidos = this.checkedUsersId;
    this.enviarSenha(() => this.inserirSenhaFechou());
  }

  private enviarSenha(onClose: () => void) {
    this.loadingGenerico = true;
    this.listarPedidosPosPagoService.postSenha(this.empresa, this.obj)
    .pipe(take(1))
    .subscribe({
      next: (success: any) => {
        this.nok = success.response.filter(i => i.status == 'NOK').length;
        this.ok = success.response.filter(i => i.status == 'OK').length;
        if (success.response.length == this.nok) {
          this.erro = true;
          this.alertErroMensagem = 'Erro ao liberar todos os pedidos.';
        } else if (success.response.length == this.ok) {
          this.alertSucesso = true;
          this.alertSucessoMensagem = 'Sucesso na liberação de todos os pedidos.';
        } else {
          this.alertInconsistencia = true;
        }
        onClose();
        this.loadingGenerico = false;
      },
      error: (error) => {
        this.alertErroMensagem = error.error.mensagem;
        this.alertSucesso = false;
        this.erro = true;
        onClose();
        this.getAllPedidos();
        this.loadingGenerico = false;
      }
    });
  }

  filtrar() {
    this.filtro = true;
    this.empresa = this.empresaSelecionada;
    this.getAllPedidos();
  }

  // BOTAO
  aprovar() {
    if (this.trocarSenha === true && this.checkedUsersId.length != 0) {
      this.showCadastrarSenha = true;
    }

    if (this.trocarSenha === false && this.checkedUsersId.length != 0) {
      this.showInserirSenha = true;
    }

    if (this.checkedUsersId.length == 0) {
      this.Toastr.error('Selecione um pedido!', '', {
        timeOut: 3000,
      });
    }
  }

  // FECHOU ALERT SUCESSO ERRO
  eventoAlertSucesso(event: any) {
    this.aprovaPedidoApi = null;
  }
  eventoAlertErro(event: any) {
    this.aprovaPedidoApi = null;
  }

  // FECHOU SENHA
  inserirSenhaFechou() {
    this.showInserirSenha = false;
  }
  cadastrarSenhaFechou() {
    this.showCadastrarSenha = false;
  }

  public limparFiltro() {
    this.empresaSelecionada = '0';
    this.empresa = localStorage.idEmpresaLogada;
    this.filtro = false;
    this.getAllPedidos();
  }

  // VALIDACAO DAS SENHAS

  public forcaSenha() {
    this.forca = 0;

    if (
      this.form.value.senha.length >= 1 &&
      this.form.value.senha.length <= 5
    ) {
      this.forca += 10;
    } else if (this.form.value.senha.length >= 9) {
      this.forca += 16;
    }

    if (this.form.value.senha.length > 0 && this.form.value.senha.length < 9) {
      this.forca += 10;
    }

    if (
      (this.form.value.senha.length >= 5 &&
        this.form.value.senha.match(/[a-z]+/)) ||
      this.form.value.senha.match(/[A-Z]+/)
    ) {
      this.forca += 8;
    }

    if (
      this.form.value.senha.length >= 5 &&
      this.form.value.senha.match(/\d+/)
    ) {
      this.forca += 8;
    }

    if (
      this.form.value.senha.length >= 7 &&
      this.form.value.senha.match(/[@#$%&;*]/)
    ) {
      this.forca += 25;
    }
    this.informarRegras();
    this.mostrarForca();
  }

  public mostrarForca() {
    if (this.forca < 30) {
      this.senhaForca = 'Fraca';
    } else if (this.forca >= 30 && this.forca < 50) {
      this.senhaForca = 'Moderada';
    } else if (this.forca >= 50) {
      this.senhaForca = 'Forte';
    }
  }

  public informarRegras() {
    if (this.form.value.senha.length < 9) {
      this.informarCaracter = 'Sua senha deve ter no mínimo 9 caracteres.';
    }

    if (
      !this.form.value.senha.match(/[a-z]+/) ||
      this.form.value.senha.match(/[A-Z]+/)
    ) {
      this.informarLetras = 'Sua senha deve conter letras';
    }

    if (!this.form.value.senha.match(/\d+/)) {
      this.informarNumeros = 'Sua senha deve conter números.';
      this.confereNumero = true;
    }

    if (this.form.value.senha.length >= 9) {
      this.informarCaracter = ' ';
    }

    if (
      this.form.value.senha.match(/[a-z]+/) ||
      this.form.value.senha.match(/[A-Z]+/)
    ) {
      this.informarLetras = ' ';
    }

    if (this.form.value.senha.match(/\d+/)) {
      this.informarNumeros = ' ';
      this.confereNumero = false;
    }
  }

  senhasConferem() {
    let senha = this.form.value.senha;
    let repSenha = this.form.value.confirmarSenha;
    let senhaAntiga = this.form.value.senhaAtual;

    if (senha != repSenha && repSenha != null) {
      this.mensagemSenha = 'As senhas não conferem !';
      this.confereSenha = false;
    } else {
      this.mensagemSenha = '';
    }

    if (senha == repSenha) {
      this.confereSenha = true;
    }

    if (senha == senhaAntiga && senha != null && senhaAntiga != null) {
      this.mensagemSenhaIguais = 'A senha atual e a senha nova são iguais';
    }
    if (senha != senhaAntiga) {
      this.mensagemSenhaIguais = '';
    }
  }

  public replace() {
    this.form.value.senha = this.form.value.senha.replace('^', '');
    this.form.value.senha = this.form.value.senha.replace("'", '');
    this.form.patchValue({ senha: this.form.value.senha });
  }

  public replaceRepSenha() {
    this.form.value.confirmarSenha = this.form.value.confirmarSenha.replace(
      '^',
      ''
    );
    this.form.value.confirmarSenha = this.form.value.confirmarSenha.replace(
      "'",
      ''
    );
    this.form.patchValue({ confirmarSenha: this.form.value.confirmarSenha });
  }

  replaceSenhaAtual() {
    this.form.value.senhaAtual = this.form.value.senhaAtual.replace('^', '');
    this.form.value.senhaAtual = this.form.value.senhaAtual.replace("'", '');
    this.form.patchValue({ senhaAtual: this.form.value.senhaAtual });
  }

  public isErrorField(field) {
    return (
      this.form.get(field).valid === false &&
      this.form.get(field).touched === true
    );
  }

  public revelaEscondeSenha() {
    const inputSenha = document.querySelector<HTMLInputElement>('#inputSenha');
    const iconeOlho = document.querySelector<HTMLInputElement>('#iconeOlho');

    if (inputSenha.type == 'password') {
      inputSenha.type = 'text';
      iconeOlho.classList.remove('fa-eye');
      iconeOlho.classList.add('fa-eye-slash');
    } else {
      inputSenha.type = 'password';
      iconeOlho.classList.remove('fa-eye-slash');
      iconeOlho.classList.add('fa-eye');
    }
  }
  public revelaEscondeSenhaConfirmar() {
    const inputSenha = document.querySelector<HTMLInputElement>('#confirmarSenha');
    const iconeOlho = document.querySelector<HTMLInputElement>('#iconeOlho2');

    if (inputSenha.type == 'password') {
      inputSenha.type = 'text';
      iconeOlho.classList.remove('fa-eye');
      iconeOlho.classList.add('fa-eye-slash');
    } else {
      inputSenha.type = 'password';
      iconeOlho.classList.remove('fa-eye-slash');
      iconeOlho.classList.add('fa-eye');
    }
  }

  public revelaEscondeSenhaAtual() {
    const inputSenha =document.querySelector<HTMLInputElement>('#senhaAtual');
    const iconeOlho = document.querySelector<HTMLInputElement>('#iconeOlho3');

    if (inputSenha.type == 'password') {
      inputSenha.type = 'text';
      iconeOlho.classList.remove('fa-eye');
      iconeOlho.classList.add('fa-eye-slash');
    } else {
      inputSenha.type = 'password';
      iconeOlho.classList.remove('fa-eye-slash');
      iconeOlho.classList.add('fa-eye');
    }
  }

  public fecharAlertSucesso() {
    this.alertSucesso = false;
    this.windowRef.reload();
  }

  public fecharAlertErro() {
    this.erro = false;
    this.windowRef.reload();
  }
  public fecharAlertInconsistencia() {
    this.alertInconsistencia = false;
    this.windowRef.reload();
  }

  selecionaTodos(input: any) {
    const checkboxes = document.querySelectorAll("input[type='checkbox']");

    function transformAllTrue(item: any) {
      item.checked = true;
    }
    function transformAllFalse(item: any) {
      item.checked = false;
    }

    if (input.checked === true) {
      checkboxes.forEach(transformAllTrue);
    } else {
      checkboxes.forEach(transformAllFalse);
    }
  }
}
